var _circle, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 5,
    r: 5,
    fill: "white",
    style: {
      mixBlendMode: "multiply"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 5,
    r: 3,
    fill: "#6366F1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1208_11099",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5007 13.9094L1.79765 4.94748C1.44461 4.39271 1.84313 3.66675 2.5007 3.66675H17.5007C18.1583 3.66675 18.5568 4.39271 18.2038 4.94748L12.5007 13.9094V17.8334C12.5007 18.1491 12.3224 18.4376 12.04 18.5788L8.70671 20.2454C8.15263 20.5225 7.5007 20.1196 7.5007 19.5001V13.9094ZM4.01876 5.33341L9.03709 13.2194C9.12217 13.3531 9.16737 13.5083 9.16737 13.6667V18.1517L10.834 17.3184V13.6667C10.834 13.5083 10.8792 13.3531 10.9643 13.2194L15.9826 5.33341H4.01876Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1208_11099)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 10C18.1256 10 19.1643 9.62806 20 9.00037V22H0V2H12.9996C12.3719 2.83566 12 3.87439 12 5C12 7.76142 14.2386 10 17 10Z",
    fill: "#4F46E5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSort);
export default __webpack_public_path__ + "static/media/activeSort.0413f423.svg";
export { ForwardRef as ReactComponent };